import { useState } from 'react';
import { notification } from 'tea-component';
import { setLikeInsightsReport } from '../../services/reportService';
import { useRequest } from 'ahooks';

import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { getBasePath } from '@/utils/utils';

export default props => {
  const {
    data = { title: '' },
    isNew = false,
    hasPDF = false,
    systemId = '',
    lang = 0,
    isMur = false,
    type = '',
    handleDownloadRun,
    needPopover = false,
  } = props;

  const jumpTo = (link: string) => {
    const w = window.open('_black');
    const url = link;
    w.location.href = url;
  };

  const [showDetail, setShowDetail] = useState(false);
  const [reportUrl, setReportUrl] = useState('');
  const [reportUrlOri, setReportUrlOri] = useState('');
  const [reportLoading, setReportLoading] = useState(true);

  /** 分享Bubble */
  const [shareBubble, setShareBubble] = useState(false);
  /** 点赞Bubble */
  const [likeBubble, setLikeBubble] = useState(false);

  const [likeCnt, setLikeCnt] = useState(data.report_like);

  /**
   * @description: 获得预览pdf
   * @param {any} systemId mobile和market的区别
   * @param {any} resourceId
   * @param {en|cn} lang 报告语种
   * @return {*}
   */
  const getReportShow = async (systemId: any, resourceId: any, lang = 'en') => {
    setReportLoading(true);
    setReportUrl('');
    setReportUrlOri('');
    try {
      const authorization = window.sessionStorage.getItem('authorization');
      const xhr = new XMLHttpRequest();
      xhr.open(
        'GET',
        `/api/v1/util/resource/${systemId}/${resourceId}/${lang}`,
      );
      xhr.responseType = 'blob';
      xhr.setRequestHeader('authorization', authorization);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === xhr.DONE) {
          if (xhr.status === 200) {
            let fileUrl = window.URL.createObjectURL(
              new Blob([xhr.response], {
                type: 'application/pdf;chartset=UTF-8',
              }),
            );
            setReportUrlOri(fileUrl);
            fileUrl += '#scrollbars=0&toolbar=0&statusbar=0&view=FitH,top';
            setReportUrl(fileUrl);
            setReportLoading(false);
          }
        }
      };
      xhr.send();
    } catch (e) {
      console.log(e);
    }
  };

  const downloadReports = async (resourceId: any) => {
    try {
      if (reportUrlOri) {
        const downloadElement = document.createElement('a');
        downloadElement.href = reportUrlOri;
        downloadElement.download = resourceId;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        notification.success({
          description: 'Download Success',
          duration: 3000,
        });
      } else {
        notification.error({
          description: 'Download Failed',
          duration: 3000,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onLikeClick = async (resourceId: any, type?: string) => {
    // console.log("click like")
    const typeValue = type || 'intelligence_insights';
    try {
      const likeCounts = await setLikeInsightsReport({
        system: typeValue,
        resource_id: resourceId || '',
      });

      // setLikeCnt(likeCounts);
      setLikeBubble(true);
      setShareBubble(false);
      let btnLogMes = dbiBtnLogMes.insightsReportsLike;
      switch (typeValue) {
        case 'gameResearch':
          btnLogMes = dbiBtnLogMes.gameResearchLike;
          break;
        case 'intelligence_insights':
          btnLogMes = dbiBtnLogMes.insightsReportsLike;
          break;
        case 'intelligence_iic':
          btnLogMes = dbiBtnLogMes.insightsCenterLibraryLike;
          break;
        case 'game_analysis':
          btnLogMes = dbiBtnLogMes.gameAnalysisLike;
          break;
        case 'intelligence_ai':
          btnLogMes = dbiBtnLogMes.aiHubReportsLike;
          break;
      }

      // const BtnLogMes = dbiBtnLogMes.insightsReportsLike;
      buriedBtnPoint({ ...btnLogMes, extInfo: resourceId });

      setTimeout(() => {
        setLikeBubble(false);
      }, 4000);

      // 将当前点赞数抛出
      return likeCounts;
    } catch (e) {
      console.log(e);
    }
  };

  const { run } = useRequest(onLikeClick, {
    // throttleWait: 3000,
    throttleTrailing: false,
    manual: true,
  });

  const onShareClick = async (resourceId: any) => {
    // console.log("click share",resourceId)
    const name =
      lang === 0
        ? ' 来看看我分享的这篇洞察报告吧!'
        : 'Check out this insight report!';
    const text = `${name} ${
      window.location.origin
    }${getBasePath()}/intelligence/reports/insightsReports/?id=${
      resourceId || ''
    }`;

    try {
      const { clipboard } = navigator;
      // Firefox 不支持 "clipboard-read" 和 "clipboard-write" 权限
      if (clipboard) {
        await clipboard.writeText(text);

        const BtnLogMes = dbiBtnLogMes.insightsReportsShare;
        BtnLogMes.extInfo = text;

        buriedBtnPoint(BtnLogMes);
      }
      setLikeBubble(false);
      setShareBubble(true);

      setTimeout(() => {
        setShareBubble(false);
      }, 4000);
    } catch (e) {
      console.log(e);
    }
  };

  return {
    getReportShow,
    reportUrl,
    data,
    isNew,
    hasPDF,
    systemId,
    setShowDetail,
    showDetail,
    jumpTo,
    reportLoading,
    setReportLoading,
    downloadReports,
    onLikeClick,
    onShareClick,
    shareBubble,
    likeBubble,
    likeCnt,
    setLikeCnt,
    run,
    setLikeBubble,
    isMur,
    type,
    handleDownloadRun,
    needPopover,
  };
};
